import FeedCard from "./FeedCard";

export default function VideoFeedCardSkeleton() {
  return (
    <FeedCard variant="horizontal-video">
      <div className="flex flex-col gap-2 animate-pulse">
        {/* Header skeleton */}
        <div className="flex flex-row items-center justify-between px-3 md:px-0">
          <div className="flex flex-row items-center w-full gap-2.5 md:gap-3">
            {/* Avatar skeleton */}
            <div className="w-[50px] h-[50px] rounded-full bg-gray-200" />

            {/* Name and timestamp skeleton */}
            <div className="flex flex-col gap-1">
              <div className="h-5 w-32 bg-gray-200 rounded" />
              <div className="h-3 w-16 bg-gray-200 rounded" />
            </div>

            {/* Subscribe button skeleton */}
            <div className="h-9 w-24 bg-gray-200 rounded ml-auto" />
          </div>
        </div>

        {/* Video placeholder skeleton */}
        <div className="w-full aspect-video bg-gray-200" />

        {/* Title and actions skeleton */}
        <div className="px-4 md:px-0 flex flex-col gap-3">
          <div className="h-7 w-3/4 bg-gray-200 rounded" />

          {/* Action buttons skeleton */}
          <div className="flex flex-row justify-between">
            <div className="h-9 w-24 bg-gray-200 rounded" />
            <div className="h-9 w-24 bg-gray-200 rounded" />
          </div>
        </div>
      </div>
    </FeedCard>
  );
}
